import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import { UTILS } from "../../constants";
import axios from "axios";

export const DatesPopup = ({ setgetId, cardDetail, setSavedDate, saveDate }) => {
  // console.log("cardDetailDatesPopup", cardDetail);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isStartDateEnabled, setIsStartDateEnabled] = useState(false);
  const [rangeSelection, setRangeSelection] = useState(false);

  useEffect(() => {
    if(cardDetail?.is_check_start_date == 1){
      setIsStartDateEnabled(true);
      // setStartDate(new Date(cardDetail.start_date));
      setStartDate((cardDetail.start_date ? new Date(cardDetail.start_date) : new Date()));
      setEndDate((cardDetail.due_date ? new Date(cardDetail.due_date) : new Date()));
      setRangeSelection(true);
    }else{
      setStartDate(null);
      setEndDate((cardDetail.due_date ? new Date(cardDetail.due_date) : new Date()));
      // setEndDate(new Date(cardDetail.start_date));
      setRangeSelection(false);
      setIsStartDateEnabled(false);
    }
    // console.log("cardDetail",cardDetail);
    // if(cardDetail?.start_date && cardDetail?.due_date) {
    //   setStartDate(new Date(cardDetail.start_date));
    //   setEndDate(new Date(cardDetail.due_date));
    //   setRangeSelection(true);
    //   setIsStartDateEnabled(true);
    // } else if (cardDetail?.start_date) {
    //   setStartDate(new Date(cardDetail.start_date));
    //   setEndDate(null);
    //   setRangeSelection(false);
    //   setIsStartDateEnabled(true);
    // } else if (cardDetail?.due_date) {
    //   setStartDate(null);
    //   setEndDate(new Date(cardDetail.due_date));
    //   setRangeSelection(false);
    //   setIsStartDateEnabled(false);
    // }
  }, [cardDetail]);

  function formatDate(date) {
    return date ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` : '';
  }

  const handleDateChange = (dates) => {
    const [start, end] = Array.isArray(dates) ? dates : [dates];
    if (rangeSelection) {
      setStartDate(start);
      setEndDate(end);
    } else {
      setStartDate(null); // Clear start date
      setEndDate(start); // Set the single date to end date
    }
  };

  const handleCheckboxChange = () => {
    if (isStartDateEnabled) {
      // When disabling the start date, set end date to start date
      setEndDate(startDate);
      setStartDate(null); // Clear start date
    } else {
      // When enabling the start date, clear end date
      setEndDate(null);
    }
    setIsStartDateEnabled(!isStartDateEnabled);
    setRangeSelection(!rangeSelection);
  };

  const onSubmitDate = async () => {
    try {
      const apiUrl = UTILS.API_url + "board/v1/board-list-cards/date/update";

      const currentDate = new Date();
      const startDateFormatted = startDate
        ? startDate.toLocaleDateString("en-US")
        : currentDate.toLocaleDateString("en-US");
      const endDateFormatted = endDate
        ? endDate.toLocaleDateString("en-US")
        : currentDate.toLocaleDateString("en-US");

      // Construct FormData
      const formData = new FormData();
      formData.append("task_id", cardDetail?.id);
      formData.append('is_check_start_date', isStartDateEnabled ? 1 : 0);
      formData.append("is_check_due_date", endDate ? 1 : 0);
      formData.append("start_date", startDateFormatted);
      formData.append("due_date", endDateFormatted);

      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("trelloToken")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setSavedDate(response.data);
      setgetId(null);
    } catch (error) {
      console.error("Error fetching board data:", error);
    }
  };

  return (
    <div className="add-member">
      <button className="close-btn-pop close-member">
        <span
          className="material-symbols-outlined"
          onClick={() => setgetId(null)}
        >
          close
        </span>
      </button>
      <h4 className="mem-heading">Dates</h4>

      <div className="modal-start-date">
        <div className="input-date-group">
          <DatePicker
            selected={endDate} // Show endDate as selected date
            onChange={handleDateChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange={rangeSelection}
            inline
            disabled={!isStartDateEnabled && !rangeSelection}
            dateFormat="MM/dd/yyyy"
            selectsStart={rangeSelection} // Enable start date selection for range
            selectsEnd={rangeSelection} // Enable end date selection for range
          />
        </div>
      </div>
      <div className="bothSection">
        <h4 className="due-heading">Enable Start Date</h4>
        <div className="enable_date_section">
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <input
              type="checkbox"
              id="check-start-date"
              checked={isStartDateEnabled}
              onChange={handleCheckboxChange}
              className="checkedBox"
            />
          </div>
          <div className="modal-start-date">
            <input
              type="text"
              id="board-start-date"
              placeholder="M/D/YYYY"
              className="start_date"
              value={(isStartDateEnabled)?(startDate ? formatDate(startDate) : ''):''}
              disabled={!isStartDateEnabled} // Ensure this input is disabled if checkbox is unchecked
            />
          </div>
        </div>
        <div className="due_section">
          <h4 className="due-heading">Due date</h4>
          <div className="modal-due-date">
            <input
              type="text"
              id="board-due-date"
              placeholder="M/D/YYYY"
              value={endDate ? formatDate(endDate) : ''}
              disabled
            />
          </div>
        </div>
      </div>

      <button
        className="show-btn date-cal-btn"
        id="board-dates-save-btn"
        onClick={onSubmitDate}
      >
        Save
      </button>
      <button className="show-btn" id="board-dates-remove-btn">
        Remove
      </button>
    </div>
  );
};
